import { lazyLoadMedia } from './utils/lazyload';
import { initSwiper } from './library/swiper';
import { Tabs } from "./library/tabs";
import { initFancybox } from './library/fancybox';
import { initNotyf } from './library/notification';
import { initTooltip } from './library/typpy';
import { initMarquee } from './library/marquee';
import { modal } from './library/modal';
import { initAccordion } from './library/accordion';
import {TabsDropdown} from "./main/TabsDropdown";
import {FooterAccordion} from "./main/FooterAcordion";
import {initHeader} from "./main/initHeader";
import {initMap} from "./main/initMap";
import {phone} from "./main/phone";
import {initTabSlide} from "./main/initTabSlide";
import {initHeaderMobileMenu} from "./main/initHeaderMobileMenu";
import { OverlayScrollbars } from "overlayscrollbars";
import {initSelect} from "./main/initSelect";
import {initAnchor} from "./main/initAnchor";
import {initTabs} from "./library/initTabs";
import {initProductGradient} from "./main/initProductGradient";
import {initCopy} from "./main/initCopy";

/*import 'dragscroll';*/
document.addEventListener('DOMContentLoaded', () => {
    lazyLoadMedia();
    //initAccordion();
    initSwiper();
    new TabsDropdown();
    new FooterAccordion('.footer-contact__item');
    initFancybox();
    initHeader();
    initMap();
    phone();
    initTabSlide();
    initSelect();
    initHeaderMobileMenu();
    initCopy();
    initAnchor();
    initTabs('.main-tabs');
    initProductGradient();
    // initNotyf();
    // initTooltip();
    // initMarquee();
    modal;
    document.querySelectorAll<HTMLElement>('.tabs').forEach(tabContainer => new Tabs(tabContainer));
    document.querySelectorAll<HTMLElement>("[data-overlayscrollbars-initialize]")
        .forEach(el => {
            OverlayScrollbars(el, {
                scrollbars: {
                    autoHide: 'leave'
                }
            });
        });
});

